import { FC, useEffect, useState } from 'react';
import { Markdown } from '../../Markdown';
import { message as AntdMessage } from 'antd';
import logoSvg from '../../../images/logo.svg';
import { LikeStatus } from '../../../type';
import { useRequest } from 'ahooks';
import { addSuggestions, getSuggestionType, thumpUp } from './service';
import { cacheKey } from '../../../../../utils/const';
import { Button, Input, Modal } from 'antd';
import copyToClipboard from 'copy-to-clipboard';

import copySvg from './copy.svg';
import unUpSvg from './unUp.svg';
import upEdSvg from './upEd.svg';
import downSvg from './down.svg';
import unDownSvg from './unDown.svg';
import { useLanguageStore } from '../../../../../hooks';
import useI18n from '../../../../../hooks/useI18n';

export interface IMessageItem {
  type: 'User' | 'Ai';
  content: string;
  likeStatus: LikeStatus;
  id: string;
}

export interface IMessageBoxProps {
  message: IMessageItem;
  loading: boolean;
  responding: boolean;
}

export const MessageBox: FC<IMessageBoxProps> = (props) => {
  const { message, loading, responding } = props;
  const [itemLikeStatus, setItemLikeStatus] = useState(message.likeStatus);
  const [open, setOpen] = useState(false);
  const [suggestion, setSuggestion] = useState<number[]>([]);
  const [suContent, setSuContent] = useState<string>('');
  const { lang } = useLanguageStore();
  const { data } = useRequest(() => getSuggestionType({ lang }), {
    cacheKey: `${cacheKey.SuggestionType}${lang}`,
    staleTime: 60 * 1000,
    refreshDeps: [lang],
  });
  const PostThumpUp = (nextStatus: LikeStatus) => {
    if (itemLikeStatus === nextStatus) {
      nextStatus = LikeStatus.default;
    }
    setItemLikeStatus(nextStatus);
    thumpUp({
      id: Number(message.id),
      likeStatus: nextStatus,
    });
  };

  useEffect(() => {
    if (!open) {
      setSuggestion([]);
      setSuContent('');
    }
  }, [open]);

  const i18n = useI18n();
  const submitSuggestion = () => {
    addSuggestions({
      chatId: message.id,
      suContent,
      suType: suggestion?.toString() || '',
    });
  };
  const onCopy = () => {
    const copySuccess = copyToClipboard(message.content);
    if (copySuccess) {
      AntdMessage.success(i18n('Copied'));
    } else {
      AntdMessage.success('复制失败，请重试');
    }
  };

  // const

  return (
    <div className="self-start flex">
      <div className="w-8 h-8 mr-4 shrink-0">
        <img src={logoSvg} alt="" />
      </div>
      <div>
        {loading && (
          <img
            className="w-8 h-8"
            src="https://oss-saas.carbonstop.net/carbonAI/loading.gif"
            alt=""
          />
        )}
        <Markdown content={props.message.content} />
        {!loading && !responding && (
          <div className="flex content-start gap-6 mt-8">
            <div
              className="cursor-pointer hover:bg-[#E6FFF6] rounded-2xl"
              onClick={() => PostThumpUp(LikeStatus.like)}
            >
              <img
                src={itemLikeStatus === LikeStatus.like ? upEdSvg : unUpSvg}
                alt=""
              />
            </div>
            <div
              className="cursor-pointer hover:bg-[#E6FFF6] rounded-2xl"
              onClick={() => {
                if (itemLikeStatus !== LikeStatus.dislike) {
                  setOpen(true);
                } else {
                  PostThumpUp(LikeStatus.dislike);
                }
              }}
            >
              <img
                src={
                  itemLikeStatus === LikeStatus.dislike ? downSvg : unDownSvg
                }
                alt=""
              />
            </div>
            <div
              onClick={() => onCopy()}
              className="hover:text-[#0CBF9F] cursor-pointer hover:bg-[#E6FFF6] rounded-2xl"
            >
              <img src={copySvg} alt="" />
            </div>
            <Modal
              centered
              mask={false}
              open={open}
              title={i18n('Thank you for your feedback')}
              footer={null}
              onCancel={() => setOpen(false)}
            >
              <div className="flex gap-3 flex-wrap mb-4">
                {data?.data.data.map((item) => (
                  <div
                    key={item.code}
                    className={`border-[1px] border-solid border-[#04252B15] cursor-pointer rounded-lg h-8 leading-8 px-4 ${suggestion?.includes(item.code) ? 'bg-[#04252B13] border-white' : ''}`}
                    onClick={() =>
                      setSuggestion((pre) => {
                        if (pre?.includes(item.code)) {
                          return pre.filter((preItem) => preItem !== item.code);
                        } else {
                          return [...pre, item.code];
                        }
                      })
                    }
                  >
                    {item.name}
                  </div>
                ))}
              </div>
              <Input
                className="mb-4"
                value={suContent}
                onChange={(e) => setSuContent(e.target.value)}
                placeholder={i18n('haveOtherQuestions')}
              />
              <Button
                type="primary"
                onClick={() => {
                  setOpen(false);
                  PostThumpUp(LikeStatus.dislike);
                  submitSuggestion();
                }}
              >
                {i18n('submit')}
              </Button>
            </Modal>
          </div>
        )}
      </div>
    </div>
  );
};
